// src/pages/cliente/AccumulatePointsPage.jsx

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';
import QRScannerButton from '../../components/common/QRScannerButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const AccumulatePointsPage = () => {
    const { tiendaId } = useParams();
    const [ticket, setTicket] = useState(null);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(false);

    // Cargar productos de la tienda
    useEffect(() => {
        const fetchProductos = async () => {
            try {
                if (tiendaId) {
                    const response = await get(`tiendas/${tiendaId}/productos`);
                    setProductos(response || []);
                }
            } catch (error) {
                console.error('Error loading productos:', error);
            }
        };

        fetchProductos();
    }, [tiendaId]);

    const handleAccumulateSuccess = (result) => {
        // Mostrar mensaje de éxito
        Swal.fire({
            title: '¡Puntos Acumulados!',
            html: `
      <div class="text-center">
        <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 text-2xl" />
        </div>
        <p class="text-lg font-semibold text-gray-800 mb-2">
          ¡Transacción completada exitosamente!
        </p>
        <p class="text-gray-600">
          Los puntos han sido acumulados correctamente
        </p>
      </div>
    `,
            icon: 'success',
            confirmButtonText: 'Aceptar'
        });

        // Actualizar el ticket si se proporciona
        if (result && result.ticket) {
            setTicket(result.ticket);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto">
                <div className="bg-white rounded-xl shadow-lg p-8">
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FontAwesomeIcon icon={faQrcode} className="text-blue-600 text-2xl" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-800 mb-2">
                            Acumular Puntos
                        </h1>
                        <p className="text-gray-600">
                            Escanea el código QR del ticket del cliente para acumular puntos automáticamente
                        </p>
                    </div>

                    <div className="text-center">
                        <QRScannerButton
                            buttonText="Escanear QR del Cliente"
                            className="px-8 py-4 text-lg"
                            productos={productos}
                            onAccumulateSuccess={handleAccumulateSuccess}
                            tiendaId={tiendaId} // ✅ PASAR TIENDA ID
                        />
                    </div>

                    {loading && (
                        <div className="mt-6 text-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
                            <p className="text-gray-600">Procesando...</p>
                        </div>
                    )}

                    {ticket && (
                        <div className="mt-8 p-4 bg-green-50 rounded-lg border border-green-200">
                            <div className="flex items-center">
                                <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 mr-2" />
                                <div>
                                    <h3 className="font-semibold text-green-800">Ticket Actualizado</h3>
                                    <p className="text-sm text-green-700">
                                        Puntos actuales: {ticket.puntos || 0}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                        <h3 className="font-semibold text-blue-800 mb-2">Instrucciones:</h3>
                        <ul className="text-sm text-blue-700 space-y-1">
                            <li>• Pide al cliente que muestre su ticket con QR</li>
                            <li>• Haz clic en "Escanear QR del Cliente"</li>
                            <li>• Apunta la cámara hacia el código QR</li>
                            <li>• El sistema abrirá automáticamente el formulario de acumulación</li>
                            <li>• Ingresa los datos y confirma la transacción</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccumulatePointsPage;

